<div class="view-wrapper" @viewLoader>
  <div class="view-content xl">
    <div class="view-section">
      @if (job(); as currentJob) {
        <div class="job-hero ct-card">
          <app-platform-company-logo [companyName]="currentJob.companyName" [companyId]="currentJob.companyId" />
          <div class="details">
            <div class="title-row">
              <span class="company text-muted">{{ currentJob.companyName }}</span>
              @if (currentJob.invited) {
                <ct-lib-tag [variant]="TagVariant.DEFAULT">
                  {{ 'jobboard.platform.recommendations.invited-tag' | transloco }}
                </ct-lib-tag>
              }
              @if (currentJob.score != null) {
                <ct-lib-score-chip
                  [score]="currentJob.score ?? undefined"
                  [label]="scoreLabelKey() | transloco"
                  [showChevron]="false"
                  [small]="true"
                />
              }
              @if (!currentJob.open) {
                <ct-lib-tag [variant]="TagVariant.GRAY">
                  {{ 'jobboard.platform.jobs.saved.closed-tag' | transloco }}
                </ct-lib-tag>
              }
            </div>
            <h4 class="title">{{ currentJob.jobTitle }}</h4>
            <div class="meta text-muted">
              <span>{{ currentJob.location }}</span>
              <span>{{ currentJob.salary }}</span>
              <span>{{ workingModelLabelKey() | transloco }}</span>
              <span>{{ employmentTypeKey() | transloco }}</span>
              <span>{{ workingTimeKey() | transloco }}</span>
            </div>
            @if (currentJob.website) {
              <a class="website" [href]="currentJob.website" target="_blank" rel="noopener noreferrer">
                {{ 'jobboard.static.header.website' | transloco }}
                <fa-icon [icon]="icons.external" aria-hidden="true"></fa-icon>
              </a>
            }
          </div>
          <div class="actions">
            <app-platform-job-bookmark-button
              [payload]="jobs.bookmarkPayloadFromBoardJob(currentJob)"
            />
            @if (currentJob.open && !jobs.hasAppliedToBoardJob(currentJob)) {
              <app-button
                variant="white-grey"
                [iconStart]="icons.pen"
                [routerLink]="['/jobs', 'recommendations', currentJob.id, 'apply']"
              >
                {{ 'jobboard.platform.apply-with-profile.manual-cta' | transloco }}
              </app-button>
              <app-button variant="primary" [iconStart]="icons.apply" (click)="apply()">
                {{ applyLabelKey() | transloco }}
              </app-button>
            }
          </div>
        </div>

        <div class="job-body ct-card">
          <h5>{{ 'jobboard.platform.recommendations.job-detail.description' | transloco }}</h5>
          @for (paragraph of currentJob.description; track $index) {
            <p>{{ paragraph }}</p>
          }
          @if (currentJob.skills.length > 0) {
            <h5>{{ 'jobboard.platform.recommendations.job-detail.skills' | transloco }}</h5>
            <div class="skills">
              @for (skill of currentJob.skills; track skill) {
                <ct-lib-tag [variant]="TagVariant.GRAY">{{ skill }}</ct-lib-tag>
              }
            </div>
          }
        </div>
      } @else {
        <div class="ct-card">
          <ct-lib-empty-placeholder
            [icon]="icons.search"
            [title]="'jobboard.platform.recommendations.job-detail.missing-title' | transloco"
            [text]="'jobboard.platform.recommendations.job-detail.missing-text' | transloco"
          />
        </div>
      }
    </div>
  </div>
</div>
